import React, {useState, useEffect} from 'react';
import './SavingTrees.css';
import tsgLogo from '../../../images/logo.png';

const SavingTrees = (props) => {
    
    let c02Reduction = props.co2Road - props.co2Sea;
    let kgC02Saved = c02Reduction * 1;
    let savedTrees2 = kgC02Saved / 21;

    const [containers, setContainer] = useState(1);
    const [c02Saved, setC02Saved] = useState(kgC02Saved);
    const [savedTrees, setSavedTrees] = useState(Math.round(savedTrees2));

    const onContainersRangeChange = (event) => 
    {
        let c02Reduction = props.co2Road - props.co2Sea;
        let kgC02Saved = c02Reduction * event.target.value;
        let savedTrees = kgC02Saved / 21;
        setSavedTrees(Math.round(savedTrees));
        setC02Saved(kgC02Saved);
        setContainer(event.target.value);
    }
 
    
    return (
        <div className="tsg-save-trees-container">
            <div className="tsg-save-trees-slider">
                <input type="range" min="1" max="250" defaultValue="1" onChange={onContainersRangeChange}/>
                <label>Container(s) {containers}</label>
            </div>
            <div className="tsg-save-trees-content">
                <div className="img-container">
                    <img src={tsgLogo} className="tsg-save-trees-logo"/>
                </div>
                <div className="tsg-save-trees-text">
                    <h3>When transporting with TSG</h3> 
                    With {containers} containers you will save {c02Saved} kgs of C02. 
                    That means saving {savedTrees} trees
                </div>
            </div>
        </div>
    );
}

export default SavingTrees;